// extracted by mini-css-extract-plugin
export default {"timestamp":"TimeStamp_timestamp__-c1gi"};